export default __webpack_public_path__ + "static/media/Group2605.2830cb4a.png";